import { render } from "./BookMark.vue?vue&type=template&id=09d25763&scoped=true"
import script from "./BookMark.vue?vue&type=script&lang=js"
export * from "./BookMark.vue?vue&type=script&lang=js"

import "./BookMark.vue?vue&type=style&index=0&id=09d25763&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d25763"]])

export default __exports__